import { ColorEnum } from '@/constants/color'
import Button from '@/features/ui/buttons/components/Button'
import Typography from '@/features/ui/typography'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface ErrorProps {
    title: string
    message: string
    retry?: () => Promise<void>
    retryAction?: string
}

const Error: FC<ErrorProps> = ({ title, message, retry, retryAction }) => {
    const { t } = useTranslation()

    const [retryDisabled, setRetryDisabled] = useState(false)

    const handleRetryPress = async () => {
        if (!retry) return

        setRetryDisabled(true)

        try {
            await retry()
        } finally {
            setRetryDisabled(false)
        }
    }

    return (
        <View style={styles.container}>
            <Typography.Heading>{title}</Typography.Heading>
            <Typography.Description size="large">{message}</Typography.Description>
            {retry && (
                <Button
                    type="primary"
                    disabled={retryDisabled}
                    onPress={handleRetryPress}
                    style={{ marginTop: 16 }}
                >
                    {retryAction || t('actions.retry')}
                </Button>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.WHITE,
        paddingHorizontal: 32,
        gap: 24,
    },
})

export default Error
